import { NextPageContext } from 'next';
import { Jobs } from 'features/Jobs';
import { GondolaHead } from 'components/GondolaHead/GondolaHead';
import { webAssetUrl } from 'lib/utils/imageUtils';
import { TeamsProvider } from 'lib/contexts/teamsContext';
import { HotjarHead } from 'components/HotjarHead';
import { getCurrentUserFromContext } from 'server/api/services/auth';
import { serialize } from 'lib/helpers';
import { JobService } from 'server/api/services/jobs';
import { Job, JobSearchCriteria } from 'lib/types/jobs';
import { queryToCriteria } from 'features/Jobs/utils';
import { ServiceMeta } from 'server/api/types';
import { getLogger } from 'server/logger';

const logger = getLogger(module, 'pages/jobs');

export const getServerSideProps = async (context: NextPageContext) => {
  const { query } = context;

  let jobs: Job[] = [];
  let meta = null;
  const criteria = queryToCriteria(query);

  try {
    const currentUser = await getCurrentUserFromContext(context);

    if (currentUser?.id) {
      // If there is a current user, we'll fetch posts via the API after the page loads
      // This keeps the page load fast for logged-in users, but puts posts on the page
      // for anonymous users (including crawlers)
      return {
        props: {
          jobs,
        },
      };
    }

    const response = await JobService.searchPublicJobs(criteria, currentUser);
    jobs = response.data as unknown as Job[];
    meta = response.meta;
  } catch (err) {
    logger.info(`Timed out (or errored) fetching jobs server-side ${err}`);
  }

  return {
    props: {
      jobs: serialize(jobs),
      criteria: serialize(criteria),
      meta: serialize(meta),
    },
  };
};

interface Props {
  jobs: Job[];
  meta: ServiceMeta;
  criteria: JobSearchCriteria;
}

const Index = ({ jobs, meta, criteria }: Props) => (
  <>
    <HotjarHead />
    <GondolaHead
      title="Search for jobs"
      description="Find your next career, gig, job on Gondola"
      url="https://gondola.cc/jobs"
      cardUrl={webAssetUrl('meta-data-cards/jobs.png')}
    />
    <TeamsProvider>
      <Jobs serverJobs={jobs} serverMeta={meta} serverCriteria={criteria} />
    </TeamsProvider>
  </>
);

export default Index;
